import { APPLICATIONS, INITIAL_ADD_DELETE_VERSION, INITIAL_DELETE_ALL_VERSION } from '../constant/constant';
import { selectedVersionPayload } from '../constant/types';

const initialState = {
  deleteRegion: 'us-dev',
  deleteAppChoice: APPLICATIONS.STUDIOBFF,
  deleteVersion: INITIAL_ADD_DELETE_VERSION,
  deleteLoading: false,
  VersionListAction: INITIAL_ADD_DELETE_VERSION,
  deleteVersionList: INITIAL_DELETE_ALL_VERSION,
};

export const deleteAllTabReducer = (
  state = initialState,
  action: { type: string; payload: string | selectedVersionPayload | boolean },
) => {
  switch (action.type) {
    case 'DELETE_REGION':
      return { ...state, deleteRegion: action.payload };
    case 'DELETE_LOADING':
      return { ...state, deleteLoading: action.payload };
    case 'DELETE_VERSION':
      return { ...state, deleteVersion: action.payload };
    case 'DELETE_APPLICATION':
      return { ...state, deleteAppChoice: action.payload };
    case 'VERSION_LIST':
      return { ...state, VersionListAction: action.payload };
    case 'DELETE_VERSION_LIST':
      return { ...state, deleteVersionList: action.payload };
    default:
      return state;
  }
};